import React from "react";
import { Pickaxe, Zap, Box } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProductFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "Strategic Facility Management",
    description: "We provide comprehensive oversight of ASC operations, from staffing and supply chain to regulatory compliance, ensuring your surgical facility runs at peak performance with data-driven workflows.",
    icon: <Pickaxe className="w-10 h-10 text-accent-bright drop-shadow-[0_2px_4px_rgba(0,0,0,0.4)]" strokeWidth={1.5} />
  }, {
    title: "Physician-Centric Partnership",
    description: "Our model prioritizes surgeon autonomy and clinical leadership, fostering an environment where medical professionals have the resources and freedom to focus entirely on delivering superior patient outcomes.",
    icon: <Zap className="w-10 h-10 text-accent-bright drop-shadow-[0_2px_4px_rgba(0,0,0,0.4)]" strokeWidth={1.5} />
  }, {
    title: "Optimized Revenue Growth",
    description: "Leverage our expert billing and managed care negotiation teams to maximize reimbursement rates, streamline administrative burdens, and improve the overall financial health of your medical practice.",
    icon: <Box className="w-10 h-10 text-accent-bright drop-shadow-[0_2px_4px_rgba(0,0,0,0.4)]" strokeWidth={1.5} />
  }];
  return;
}